import { metrics } from 'system/libs/metrics';
import notify from 'system/mediators/NotifyManager';

import s3 from '../../s3';
// eslint-disable-next-line
import createFolder from '../upload/tools/s3/createFolder';
import { actionListAdd } from './list';

export const BUCKET_FOLDER_CREATE_START = 'BUCKET_FOLDER_CREATE_START';
export function actionFolderCreateStart() {
    return {
        type: BUCKET_FOLDER_CREATE_START,
    };
}

export const BUCKET_FOLDER_CREATE_CANCEL = 'BUCKET_FOLDER_CREATE_CANCEL';
export function actionFolderCreateCancel() {
    return {
        type: BUCKET_FOLDER_CREATE_CANCEL,
    };
}

export const BUCKET_FOLDER_CREATE_REQUEST = 'BUCKET_FOLDER_CREATE_REQUEST';
export function actionFolderCreateRequest() {
    return {
        type: BUCKET_FOLDER_CREATE_REQUEST,
    };
}

export const BUCKET_FOLDER_CREATE_SUCCESS = 'BUCKET_FOLDER_CREATE_SUCCESS';
export function actionFolderCreateSuccess() {
    return {
        type: BUCKET_FOLDER_CREATE_SUCCESS,
    };
}

export const BUCKET_FOLDER_CREATE_FAILURE = 'BUCKET_FOLDER_CREATE_FAILURE';
export function actionFolderCreateFailure({ error }) {
    return {
        type: BUCKET_FOLDER_CREATE_FAILURE,
        data: { error },
    };
}

export function asyncActionFolderCreate({ Bucket, Prefix, name }) {
    return async function(dispatch) {
        let error = '';

        name = name.trim();

        if (!name) {
            error = 'required';
        } else if (/\//.test(name)) {
            error = 'invalid';
        } else if (!name.replace(/\./g, '').length) {
            error = 'pattern';
        } else {
            dispatch(actionFolderCreateRequest());

            const CommonPrefix = { Prefix: Prefix + name + '/' };

            try {
                await s3('headObject', { Bucket, Key: CommonPrefix.Prefix });

                error = 'exists';
            } catch (headObjectFailReason) {
                try {
                    await createFolder(name);

                    dispatch(actionFolderCreateSuccess());
                    dispatch(actionListAdd({ CommonPrefix }));
                } catch (createFolderFailReason) {
                    error = 'unknown';
                    notify.error('Не удалось создать папку');
                }
            }
        }

        if (error) {
            metrics.send({
                action: 'CreateFolderError',
            });
            dispatch(actionFolderCreateFailure({ error }));
        } else {
            metrics.send({
                action: 'CreateFolderSuccess',
            });
        }
    };
}
